import { T } from "@classdojo/web";
import { Button } from "@classdojo/web/nessie";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";

const SlideNavigation: React.FC<{
  onBack: () => void;
  onNext: () => void;
}> = ({ onBack, onNext }) => (
  <div sx={{ padding: RAW_cssValue(12), display: "flex", flexDirection: "row", alignItems: "center" }}>
    <Button data-name="slide_navigation:slide_navigation.back" kind="tertiary" onClick={onBack}>
      <T str="dojo.toolkit:slide_navigation.back" fallback="Back" />
    </Button>
    <Button data-name="slide_navigation:slide_navigation.next" sx={{ width: "100%" }} onClick={onNext}>
      <T str="dojo.toolkit:slide_navigation.next" fallback="Next" />
    </Button>
  </div>
);

export default SlideNavigation;
